import TypedNativeModules from "../internal/TypedNativeModules";

export async function logScreenView(screenName: string): Promise<void> {
  const tareBridge = TypedNativeModules.RNTareBridge;
  if (!tareBridge?.logScreenView) {
    return;
  }
  await tareBridge.logScreenView(screenName);
}
